var map = {
	"./hafid.png": 69797,
	"./image_01.png": 3616,
	"./image_01_m.png": 83876,
	"./image_02.jpg": 7443,
	"./img01.png": 86711,
	"./uud_2.png": 67626,
	"./uud_2_m.png": 73554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47901;